import Vue from 'vue'
import Vuex from 'vuex'
import myResource from "./myResource"

Vue.use(Vuex)

// export default new Vuex.Store({
//   // 用于存储数据
//   state: {
// 	token:'',
//   },
//   // 用于操作数据
//   mutations: {
//   },
//   // 用于响应组件中的动作
//   actions: {}
// })
const store = new Vuex.Store({
  // 用于存储数据
  state: {
	token:'',
	myResource,
  bqtitle:'技术支持'
  },
  
  
  // 用于操作数据
  mutations: {
	  
	  // 改变当前tab下标
	  handleCurrentTab(state, index) {
	    state.currentTab = index
	  }
  },
  // 用于响应组件中的动作
  actions: {

  }
});

export default store;